export default {
  namespaced: true,
  state: {
    name: 'admin'
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/adminStore/modules/admintest.js